import { RootState } from 'src/redux/store';
import { TModalsState } from 'src/redux/modals/modals.slice';
import { TUseModalData } from 'src/hooks/useModal';

export const selectActiveModals = (state: RootState): TModalsState['activeModals'] =>
  state.modals.activeModals;

export const selectIsModalOpened = (modalId: TUseModalData['id']) => (state: RootState): boolean =>
  state.modals.activeModals.includes(modalId);
